module.exports = __webpack_public_path__ + "img/b-home-detail@2x.d600371e.png";